import React from 'react';
import { List, Modal } from 'antd-mobile';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import { deleteActionLive, score as removeScore } from '../../../../../actions/liveDataActions';
import { deleteActionLive as removeActionLive } from '../../../../../actions/matchDataActions';
import { getIcon, removeAction } from '../../../../../services/action';
import { edit as editLive } from '../../../../../services/live';
import { withRouter } from 'react-router-dom';
import { 
    isLiveScorer, 
    substractScore, 
    extract,
    getRegularTimeForAction, 
    getAdditionalTime, 
    isLiveEnded,
    isHighlightActions,
    isLastAction
} from '../../../../../helpers';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './Action.css';
import FreeKickTeamChoice from '../../../../customForm/freekick/FreeKickTeamChoice';
import { LOGO_TEAM_URL } from '../../../../../config.env';

const Action = props => {
    const access = props.connexionReducer;
    const id = props.live.id || extract(props.live['@id'], '/', 3);
    const textMinute = props.action.data.label === 'debut'  || props.action.data.actionName === 'Fin de la séance des tirs au but' ? '' : `${getRegularTimeForAction(props.live.actions, props.action) || 0}'${getAdditionalTime(props.live.actions, props.action) > 0 ? ` + ${getAdditionalTime(props.live.actions, props.action)}` : ''}`;
    return (
        <List renderHeader={() => <div style={{fontWeight: '700'}} className='common'>{props.action.data.label === 'tab' ? props.action.data.actionName : textMinute}</div>}>
            {renderAction(props)}
            {
                (isLiveScorer([props.live]) && props.pageReducer !== 'pastMatch' && !isLiveEnded(props.live) &&
                (!isHighlightActions(props.action) || (isHighlightActions(props.action) && isLastAction(props.live.actions, props.action)) )) &&
                <div>
                    <List.Item>
                        <div style={{float: 'right'}} className='common'>
                            {
                                !_.includes(['mi_temps', 'reprise', 'mi_temps_prolongation', 'reprise_prolongation', 'fin_prolongations', 'fin_temps_reglementaire'], props.action.data.label) && 
                                <span onClick={() => props.history.push(`/live/${id}/${props.action.data.label}?action_edit=${JSON.stringify(props.action)}&score=${JSON.stringify(props.live.score)}`)}>Modifier</span>
                            }
                            <span style={{color: '#d0021b', marginLeft: '15px'}} onClick={() => {
                                props.stopInterval();
                                Modal.alert(<span style={{...styles.common, fontWeight: 700}}>Confirmation</span>, <div style={styles.common}>Veux-tu réellement supprimer cette action ?</div>, [
                                    {text: <span style={{...styles.common, fontWeight: 700}}>Annuler</span>, onPress: () => props.startInterval()},
                                    {text: <span style={{...styles.common, fontWeight: 700}}>Ok</span>, onPress: () => {confirmDelete(props, access); props.startInterval();}}
                                ])
                            }}>Supprimer</span>
                        </div>
                    </List.Item>
                </div>
            }
        </List>
    );
}

const renderAction = props => {
    if(props.action.data.label === 'tab') {
        const {match} = props.live;
        const index = _.findIndex(props.allTab, tir => tir['@id'] === props.action['@id']);
        const prevTab = _.take(props.allTab, index + 1);
        const seq = [];
        _.forEach(prevTab, prevTab => {
            seq.push({
                id: prevTab['@id'],
                team: prevTab.teamId,
                teamName: prevTab.teamName,
                player: prevTab.data.player,
                result: prevTab.data.result,
                eq: prevTab.data.eq
            })
        })
        
        return (
            <div>
                <FreeKickTeamChoice 
                    homeTeamLogo={`${LOGO_TEAM_URL}/${match.homeTeamClCod}.jpg`}
                    homeTeamName={match.homeTeamEqName || match.homeTeam}
                    awayTeamLogo={`${LOGO_TEAM_URL}/${match.awayTeamClCod}.jpg`}
                    awayTeamName={match.awayTeamEqName || match.awayTeam}
                    score={props.action.data.score}
                    seq={seq}
                />
                {
                    props.action.data.description !== '' &&
                    <List.Item>
                        <div className='common'>{_.replace(props.action.data.description, 'n°', '#')}</div>
                    </List.Item>
                }
            </div>
        );
    }
    else {
        return (
            <List.Item
                thumb={<img className={_.includes(['carton-jaune', 'carton-rouge', 'carton-blanc'], props.action.data.label) ? 'ls_picto_action' : ''} 
                src={getIcon(props.action.data.label)} alt='' />}
            >
                <span className='common' style={{fontWeight: '600'}}>{props.action.data.actionName}</span>
                <div className='common'>{_.replace(props.action.data.description, 'n°', '#')}</div>
                <div className='common'>{_.replace(props.action.data.other, 'n°', '#')}</div>
            </List.Item>
        )
    }
}

const confirmDelete = (props, access) => {
    const id = props.live.id || extract(props.live['@id'], '/', 3);
    const removedAction = [new Promise((resolve, reject) => {removeAction(props.action['@id'], access, id).then(() => resolve(props.action)).catch(() => reject())})];

    if(props.action.data.relatedAction) {
        const {relatedAction} = props.action.data;
        removedAction.push(new Promise((resolve, reject) => {removeAction(relatedAction['@id'], access, id).then(() => resolve(relatedAction)).catch(() => reject())}));
    }

    Promise.all(removedAction).then(actions => {
        _.forEach(actions, action => {
            if(action && _.includes(['but', 'penalty_resultat-marque'], action.data.label)) {
                const score = substractScore(props.live.score, action.data.category);
                props.removeScore(id,score);
                editLive(id, {score}, access);
            }
            props.deleteActionLive(id, action['@id'])
            props.removeActionLive(id, action['@id']);
        })
        
    });
}

const mapStateToProps = ({pageReducer, connexionReducer}) => ({pageReducer, connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({deleteActionLive, removeActionLive, removeScore}, dispatch);

const styles = {
    common: {
        fontFamily: 'fff-equipe',
        color: '#004586'
    }
}

Action.propTypes = {
    action: PropTypes.shape({
        '@id': PropTypes.string.isRequired,
        minute: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        data: PropTypes.shape({
            label: PropTypes.string.isRequired,
            actionName: PropTypes.string.isRequired
        }).isRequired,
        live: PropTypes.oneOfType([PropTypes.string,PropTypes.object]),
        pageReducer: PropTypes.string,
        history: PropTypes.object,
        deleteActionLive: PropTypes.func,
        removeActionLive: PropTypes.func
    }),
    startInterval: PropTypes.func,
    stopInterval: PropTypes.func
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Action));